/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const MailSpam = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
      data-palette="MailSpam">
      <path
        d="M15 5.42844L9.05385 10.7535L3 5.41195V14.25H8.30317C8.37892 14.7796 8.53373 15.2837 8.7552 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15V3C1.5 2.58579 1.83579 2.25 2.25 2.25H15.75C16.1642 2.25 16.5 2.58579 16.5 3V9.19102C16.047 8.87505 15.5418 8.62867 15 8.46742V5.42844ZM14.6257 3.75H3.38359L9.04642 8.7465L14.6257 3.75ZM12.53 15.5307C12.8237 15.6712 13.1527 15.75 13.5 15.75C14.7427 15.75 15.75 14.7427 15.75 13.5C15.75 13.1527 15.6712 12.8236 15.5307 12.5299L12.53 15.5307ZM11.4693 14.47L14.47 11.4693C14.1763 11.3287 13.8473 11.25 13.5 11.25C12.2573 11.25 11.25 12.2573 11.25 13.5C11.25 13.8473 11.3288 14.1763 11.4693 14.47ZM13.5 17.25C11.429 17.25 9.75 15.571 9.75 13.5C9.75 11.4289 11.429 9.75 13.5 9.75C15.571 9.75 17.25 11.4289 17.25 13.5C17.25 15.571 15.571 17.25 13.5 17.25Z"
        fill="currentColor"
      />
    </svg>)
  );
};

export default MailSpam;
